import { networkAction } from "helpers/network/networkAction";

import {
  GET_TIME_ASSETS,
  GET_TIME_ASSET_BY_ID,
  DELETE_TIME_ASSET,
  UPDATE_TIME_ASSET,
  CREATE_TIME_ASSET,
} from "constants/timeAssets";

import * as Api from "api";

export const getTimeAssets = (filters) => async (dispatch) =>
  networkAction(dispatch, GET_TIME_ASSETS, Api.getTimeAssets, [filters]);

export const getTimeAssetById = (id) => async (dispatch) =>
  networkAction(dispatch, GET_TIME_ASSET_BY_ID, Api.getTimeAssetById, [id]);

export const deleteTimeAsset = (id) => async (dispatch) =>
  networkAction(dispatch, DELETE_TIME_ASSET, Api.deleteTimeAsset, [id]);

export const createTimeAsset = (body) => async (dispatch) =>
  networkAction(dispatch, CREATE_TIME_ASSET, Api.createTimeAsset, [body]);

export const updateTimeAsset = (id, body) => async (dispatch) =>
  networkAction(dispatch, UPDATE_TIME_ASSET, Api.updateTimeAsset, [id, body]);
